import React from 'react'
import { VndlyWorkOrderIssuesProvider } from './context/VndlyWorkOrderIssuesProvider'
import { VndlyWorkOrderIssuesMain } from './components/VndlyWorkOrderIssuesMain'

export const VndlyWorkOrderIssues = () => {
  return (
    <VndlyWorkOrderIssuesProvider>
      <VndlyWorkOrderIssuesMain />
    </VndlyWorkOrderIssuesProvider>
  )
}
